/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React from "react";
import { Icon, SemanticICONS } from "semantic-ui-react";
import styles from "./LandingPage/LandingForm/LandingForm.module.css";

export const fieldContainer = (
  params: {
    label: string;
    errors?: any;
    actionIcon?: SemanticICONS;
    actionIconAction?: () => void;
  },
  inputParams: {
    [key: string]: any;
  }
) => {
  const { errors, label, actionIcon, actionIconAction } = params;
  const labelStyle = errors ? styles.formLabel : styles.formLabelOpt;

  return (
    <span className={styles.fieldContainer}>
      <label className={labelStyle}>{label}</label>
      <div style={{ display: "flex", alignItems: "center" }}>
        <input {...inputParams} />
        {actionIcon && actionIconAction && (
          <Icon
            name={actionIcon}
            style={{
              margin: "0 10px",
              fontSize: "16px",
              color: "#0002b3",
              cursor: "pointer",
            }}
            onClick={() => {
              actionIconAction();
            }}
          />
        )}
      </div>
      <div className={styles.fieldError}>
        {errors &&
          inputParams.name &&
          errors[inputParams.name] &&
          errors[inputParams.name].message}
      </div>
    </span>
  );
};
